import { createSelector } from '@ngrx/store';
import * as fromJobs from './jobs.reducer';

export interface State {
  jobs: fromJobs.State;
}

export const reducers = fromJobs.jobsReducer;

export const getJobsState = (state: State) => state.jobs;

export const getJobs = createSelector(
  getJobsState,
  fromJobs.getJobs
);
export const getSelectedJob = createSelector(
  getJobsState,
  fromJobs.getSelectedJobState
);
export const isJobValid = createSelector(
  getJobsState,
  fromJobs.isJobValid
);
export const getCategories = createSelector(
  getJobsState,
  fromJobs.getCategories
);
export const getJobTitleSuggestions = createSelector(
  getJobsState,
  fromJobs.getJobTitleSuggestions
);
export const getJobAssignments = createSelector(
  getJobsState,
  fromJobs.getJobAssignments
);
